export const setProfile = {
  SET_PROFILE(state, payload) {
    state.profile = payload
  }
}
